import { OrderApiError } from '@/models';
import { AnalyticsEvent } from '../models';

export class MaxEntreeErrorEvent implements AnalyticsEvent {
  name = 'MaxByocErrorEvent';

  constructor(
    public readonly error: OrderApiError,
    public readonly pceName: string,
    public readonly route: string,
    public readonly byoMealType?: string,
  ) { }
}